import { InfoTable } from "../../../../common/components/ui/table/InfoTable";
import { useVehicleDashboardContext } from "../vehicle-dashboard/useVehicleDashboardContext";

export function FipeTable() {
  const { vehicle } = useVehicleDashboardContext();


  return (
    <InfoTable
      title="Tabela Fipe"
      data={[
        { label: "Valor", value: vehicle.fipeInfo?.fipeValue },
        { label: "Marca", value: vehicle?.brand },
        { label: "Modelo", value: vehicle?.model },
        { label: "Ano", value: vehicle?.year },
        { label: "Combustível", value: vehicle?.fuel },
        { label: "Código Fipe", value: vehicle?.fipeInfo?.fipeVehicleCode },
        { label: "Mês de referência", value: vehicle?.fipeInfo?.consultDate },
      ]}
    />
  )
}
